import React from "react";
import classes from "./Search.module.css";

const SearchPage = props => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !props.disabled) {
      props.handleSearch()
    }
  };
  return <input
    className={classes[props.pushedClass]}
    type="text"
    aria-label="Search"
    spellCheck={false}
    onChange={props.changed}
    value={props.searchkeys}
    onKeyDown={handleKeyDown}
  />
};

export default SearchPage;
